import ExperimentDtoClient from 'business/models/ExperimentDtoClient';

export const fontFamilies: any[] = [
  { key: 'Arial', name: 'Arial' },
  { key: 'Calibri', name: 'Calibri' },
  { key: 'Cambria', name: 'Cambria' },
  { key: 'ComicSansMS', name: 'Comic Sans MS' },
  { key: 'Constantia', name: 'Constantia' },
  { key: 'CourierNew', name: 'Courier New' },
  { key: 'Georgia', name: 'Georgia' },
  { key: 'Roboto', name: 'Roboto' },
  { key: 'TimesNewRoman', name: 'Times New Roman' },
  { key: 'Verdana', name: 'Verdana' },
];

export const fontStyles: string[] = ['Regular', 'Bold', 'Italic', 'Bold Italic'];

export const fonts = {
  Arial: {
    normal: 'Arial-Regular.ttf',
    bold: 'Arial-Bold.ttf',
    italics: 'Arial-Italic.ttf',
    bolditalics: 'Arial-BoldItalic.ttf',
  },
  Calibri: {
    normal: 'Calibri-Regular.ttf',
    bold: 'Calibri-Bold.ttf',
    italics: 'Calibri-Italic.ttf',
    bolditalics: 'Calibri-BoldItalic.ttf',
  },
  Constantia: {
    normal: 'Constantia-Regular.ttf',
    bold: 'Constantia-Bold.ttf',
    italics: 'Constantia-Italic.ttf',
    bolditalics: 'Constantia-BoldItalic.ttf',
  },
  CourierNew: {
    normal: 'CourierNew-Regular.ttf',
    bold: 'CourierNew-Bold.ttf',
    italics: 'CourierNew-Italic.ttf',
    bolditalics: 'CourierNew-BoldItalic.ttf',
  },
  ComicSansMS: {
    normal: 'ComicSansMS-Regular.ttf',
    bold: 'ComicSansMS-Bold.ttf',
    italics: 'ComicSansMS-Italic.ttf',
    bolditalics: 'ComicSansMS-BoldItalic.ttf',
  },
  Georgia: {
    normal: 'Georgia-Regular.ttf',
    bold: 'Georgia-Bold.ttf',
    italics: 'Georgia-Italic.ttf',
    bolditalics: 'Georgia-BoldItalic.ttf',
  },
  Cambria: {
    normal: 'Cambria-Regular.ttf',
    bold: 'Cambria-Bold.ttf',
    italics: 'Cambria-Italic.ttf',
    bolditalics: 'Cambria-BoldItalic.ttf',
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Bold.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-BoldItalic.ttf',
  },
  TimesNewRoman: {
    normal: 'TimesNewRoman-Regular.ttf',
    bold: 'TimesNewRoman-Bold.ttf',
    italics: 'TimesNewRoman-Italic.ttf',
    bolditalics: 'TimesNewRoman-BoldItalic.ttf',
  },
  Verdana: {
    normal: 'Verdana-Regular.ttf',
    bold: 'Verdana-Bold.ttf',
    italics: 'Verdana-Italic.ttf',
    bolditalics: 'Verdana-BoldItalic.ttf',
  },
};

export type CaptureProfileOption = {
  id: number;
  name?: string;
  selected: boolean;
};

export type IngredientReportOptionProps = {
  docData: ExperimentDtoClient;
  canvasRef: any;
  platePadding: number;
  selectedWells: any;
};

export type IngredientReportOptionsDTO = {
  dropNumber: string;
  fitToPage: boolean;
  rowLimit: number;
  columnLimit: number;
  maxIngredients: number;
  showProteinName: boolean;
  showDropVolumes: boolean;
  showWellVolumes: boolean;
  showColumnNameHeading: boolean;
  concentration: boolean;
  pH: boolean;
  pHVolumes: boolean;
  ingredientNamePreference: string;
  drops: any[];
  fontFamily: any;
  fontStyle: string;
  isScreenExperiment: boolean;
};

export const blankImage =
  'data:image/jpeg;base64,/9j/4QAiRXhpZgAASUkqAAgAAAABAJiCAgAAAAAAAAAAAAAAAAD/4QAC/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wgARCAGaAmcDAREAAhEBAxEB/8QAJwABAQAAAAAAAAAAAAAAAAAAAAgBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAKpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB//EABQQAQAAAAAAAAAAAAAAAAAAALD/2gAIAQEAAT8Aek//xAAUEQEAAAAAAAAAAAAAAAAAAACw/9oACAECAQE/AHpP/8QAFBEBAAAAAAAAAAAAAAAAAAAAsP/aAAgBAwEBPwB6T//Z';

export const maxReportNumberDecimalPlaces = 3;

export const enum ReportSnackbarText {
  PREPARING = 'Preparing',
  LOADING = 'Loading',
}

export const pageSize = {
  a4: {
    width: 841.89,
    height: 595.28,
  },
};

export const BATCH_SIZE = 300;
